module.exports = __webpack_public_path__ + "files/2664ec19489bc1e90d00e91af6cb75d9.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/audio.png
// module id = 307
// module chunks = 60